import React from 'react';
import LabDashboard from '../components/labdashboard/LabDashboard';

export const LabsPage: React.FC = () => {
  return <LabDashboard />;
};
